import styled, { css } from 'styled-components'

import { SearchbarWidgetCard, WidgetInput } from '../widget-styles'

export const GuestsInput = styled(WidgetInput).attrs({ readOnly: true, 'aria-readonly': false })`
    user-select: none;
    cursor: pointer;
`

export const GuestPickerWidgetCard = styled(SearchbarWidgetCard)`
    min-width: 21.5rem; /* 344px. */
    max-width: 23.5rem; /* 344px. */
    right: -0.0625rem; /* -1px. */
`

export const PetsEditWrapper = styled.div(
    ({ theme }) => css`
        position: absolute;
        right: ${theme.spacing.small};
        display: flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        background-color: white;
        padding-left: 4px;
    `,
)

export const PetsEditLabel = styled.span(
    ({ theme }) => css`
        font-size: ${theme.typography.font.size.xSmall};
        color: ${theme.colors.tfwBlack40};
        white-space: nowrap;
    `,
)
